import { render, staticRenderFns } from "./SimulatorResult.vue?vue&type=template&id=4920a884&scoped=true&"
import script from "./SimulatorResult.vue?vue&type=script&lang=js&"
export * from "./SimulatorResult.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorResult.vue?vue&type=style&index=0&id=4920a884&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4920a884",
  null
  
)

export default component.exports